import {
  getMediaErrorCodeName,
  isError,
  isMediaErrorFatal,
  stringifyError,
  toError
} from "./chunk-2GHSQBQ5.js";

// src/defs/playback-session-error.ts
var PlaybackSessionErrorType = /* @__PURE__ */ ((PlaybackSessionErrorType2) => {
  PlaybackSessionErrorType2["NO_PLAYBACK_NETWORK_ERROR"] = "NO_PLAYBACK_NETWORK_ERROR";
  PlaybackSessionErrorType2["NO_PLAYBACK_DECODE_ERROR"] = "NO_PLAYBACK_DECODE_ERROR";
  PlaybackSessionErrorType2["PLAYBACK_STOPPED_NETWORK_ERROR"] = "PLAYBACK_STOPPED_NETWORK_ERROR";
  PlaybackSessionErrorType2["PLAYBACK_STOPPED_DECODE_ERROR"] = "PLAYBACK_STOPPED_DECODE_ERROR";
  PlaybackSessionErrorType2["UNSUPPORTED_FORMAT_ERROR"] = "UNSUPPORTED_FORMAT_ERROR";
  PlaybackSessionErrorType2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  return PlaybackSessionErrorType2;
})(PlaybackSessionErrorType || {});
var ErrorMessage = /* @__PURE__ */ ((ErrorMessage2) => {
  ErrorMessage2["NO_PLAYBACK_NETWORK_ERROR"] = "Failed to load the media.";
  ErrorMessage2["NO_PLAYBACK_DECODE_ERROR"] = "Failed to decode the media.";
  ErrorMessage2["PLAYBACK_STOPPED_NETWORK_ERROR"] = "Failed to load more of the media.";
  ErrorMessage2["PLAYBACK_STOPPED_DECODE_ERROR"] = "Failed to decode the next segment of media.";
  ErrorMessage2["UNSUPPORTED_FORMAT_ERROR"] = "Unsupported media format.";
  ErrorMessage2["UNKNOWN_ERROR"] = "Unknown error.";
  return ErrorMessage2;
})(ErrorMessage || {});
var PlaybackSessionError = class _PlaybackSessionError extends Error {
  constructor(type, cause, causeSummary, fatal = true) {
    super(ErrorMessage[type]);
    this.type = type;
    this.cause = cause;
    this.causeSummary = causeSummary;
    this.fatal = fatal;
    Object.setPrototypeOf(this, _PlaybackSessionError.prototype);
    this.name = "PlaybackSessionError";
  }
  static fromUnknownError(e, playbackStarted, context) {
    const error = toError(e, context);
    return new _PlaybackSessionError(
      resolveErrorType(error, playbackStarted),
      error,
      isError(e) ? error.name : error.message
    );
  }
  static fromMediaError(error, playbackStarted) {
    const errorObject = {
      name: "MediaError",
      message: error.message,
      code: error.code
    };
    return new _PlaybackSessionError(
      resolveMediaErrorType(error, playbackStarted),
      errorObject,
      getMediaErrorCodeName(error),
      isMediaErrorFatal(error)
    );
  }
  getCauseAsString() {
    return stringifyError(this.cause);
  }
};
function resolveErrorType(error, playbackStarted) {
  if (error.name === "NetworkError") {
    return playbackStarted ? "PLAYBACK_STOPPED_NETWORK_ERROR" /* PLAYBACK_STOPPED_NETWORK_ERROR */ : "NO_PLAYBACK_NETWORK_ERROR" /* NO_PLAYBACK_NETWORK_ERROR */;
  }
  if (error.name === "DecodeError") {
    return playbackStarted ? "PLAYBACK_STOPPED_DECODE_ERROR" /* PLAYBACK_STOPPED_DECODE_ERROR */ : "NO_PLAYBACK_DECODE_ERROR" /* NO_PLAYBACK_DECODE_ERROR */;
  }
  return "UNKNOWN_ERROR" /* UNKNOWN_ERROR */;
}
function resolveMediaErrorType(error, playbackStarted) {
  if (error.code === error.MEDIA_ERR_NETWORK) {
    return playbackStarted ? "PLAYBACK_STOPPED_NETWORK_ERROR" /* PLAYBACK_STOPPED_NETWORK_ERROR */ : "NO_PLAYBACK_NETWORK_ERROR" /* NO_PLAYBACK_NETWORK_ERROR */;
  }
  if (error.code === error.MEDIA_ERR_DECODE) {
    return playbackStarted ? "PLAYBACK_STOPPED_DECODE_ERROR" /* PLAYBACK_STOPPED_DECODE_ERROR */ : "NO_PLAYBACK_DECODE_ERROR" /* NO_PLAYBACK_DECODE_ERROR */;
  }
  if (error.code === error.MEDIA_ERR_SRC_NOT_SUPPORTED) {
    return "UNSUPPORTED_FORMAT_ERROR" /* UNSUPPORTED_FORMAT_ERROR */;
  }
  return "UNKNOWN_ERROR" /* UNKNOWN_ERROR */;
}

export {
  PlaybackSessionErrorType,
  PlaybackSessionError
};
